import { dailySeed, shuffled } from './daily';
import type { Category, RecipeSummary } from '@shared/schemas';

// One section = the staggered block the feed opens with, so exactly three
// recipes on phone…
export const SECTION_SIZE = 3;
// …but desktop's 4-column grid can fit one more per row — pick up to this
// many (bounded by how many the category actually has) so RecipeMosaic's
// feedCap can round the desktop row up to 4 instead of leaving it at 3.
export const DESKTOP_SECTION_SIZE = 4;
// …and a category only earns a section once it can fill one.
export const MIN_SECTION_RECIPES = 3;

export interface CategorySectionData {
  category: Category;
  /** the recipes shown in this section */
  recipes: RecipeSummary[];
  /** how many recipes the category holds in total, for the header */
  total: number;
}

// Builds the category sections shown below the home feed (#7). Categories come
// in already sorted by sort_order, so the sections line up with the chip row.
// Each section picks its recipes with the day-stable seed (offset per category
// so they don't all pick the same ones). Recipes deliberately may repeat between
// the feed and their section — a category with exactly three recipes has to be
// able to fill its block.
export function buildSections(
  recipes: readonly RecipeSummary[],
  categories: readonly Category[],
  now: Date,
): CategorySectionData[] {
  if (recipes.length === 0) return [];
  const seed = dailySeed(now);
  return categories.flatMap((category) => {
    const inCategory = recipes.filter((r) => r.category_ids.includes(category.id));
    if (inCategory.length < MIN_SECTION_RECIPES) return [];
    return [
      {
        category,
        recipes: shuffled(inCategory, seed + category.id).slice(0, DESKTOP_SECTION_SIZE),
        total: inCategory.length,
      },
    ];
  });
}
